/* eslint-disable indent */
import React from 'react'
import { Grid, Spacer, Text, useMediaQuery } from '@geist-ui/react'
import Header from './Header'

import Form from './Form'

export default function AccountSetup() {
  const isSM = useMediaQuery('sm', { match: 'up' })
  const isMD = useMediaQuery('md', { match: 'up' })

  const xsConstainerStyles = { padding: '0 3%' }
  const smConstainerStyles = { padding: '0 18px' }
  const mdConstainerStyles = {
    maxWidth: '1425px',
    margin: '0 auto',
    padding: '0 90px',
  }

  let containerStyles = xsConstainerStyles

  if (isSM) {
    containerStyles = smConstainerStyles
  }
  if (isMD) {
    containerStyles = mdConstainerStyles
  }

  return (
    <Grid.Container
      alignItems="center"
      justify="space-between"
      direction="column"
      style={{ minHeight: '100dvh', ...containerStyles }}
    >
      <Grid>
        <Grid.Container justify="space-between">
          <Header />
          <Form />
        </Grid.Container>
      </Grid>
      <Spacer h={13} />
      <Grid id="footer" style={{ width: isMD ? '100%' : '320px' }}>
        <Grid.Container>
          <Grid xs={24} md={8}>
            <div>
              <a
                href="https://waterproplan.com"
                style={{
                  cursor: 'pointer',
                }}
              >
                <img
                  alt="WaterPro Wordmark Logo"
                  style={{ height: '81px' }}
                  src="/images/WaterPro_Logo_Color.png"
                />
              </a>
            </div>
          </Grid>
          {!isMD && <Spacer h={6} />}
          <Grid direction="column" xs={24} md={8}>
            <div>
              <Text h4 font="16px" style={{ letterSpacing: '1px' }}>
                Links
              </Text>
              <ul
                className="footer-list"
                style={{ listStyleType: 'none', margin: 0, padding: 0 }}
              >
                <li>
                  <a href="https://waterproplan.com/faqs/">FAQs</a>
                </li>
                <li>
                  <a href="https://waterproplan.com/contact/">Contact</a>
                </li>
                <li>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://waterproplan.com/wp-content/uploads/2023/02/WaterPro-Guidelines_11_5-1.pdf"
                  >
                    Program Guidelines
                  </a>
                </li>
                <li>
                  <a href="https://portal.waterproplan.com/auth/">
                    Submit Claim
                  </a>
                </li>
              </ul>
            </div>
          </Grid>
          {!isMD && <Spacer h={6} />}
          <Grid direction="column" xs={24} md={8}>
            <div>
              <Text h4 font="16px" style={{ letterSpacing: '1px' }}>
                Contact
              </Text>
              <ul
                className="footer-list"
                style={{ listStyleType: 'none', margin: 0, padding: 0 }}
              >
                <li>Mon-Fri</li>
                <li>8:30 a.m. – 4:30 p.m. Eastern Time Zone</li>
                <li>888-977-7481</li>
                <li>
                  <a href="https://waterproplan.com/contact">
                    Send Us An Email
                  </a>
                </li>
              </ul>
            </div>
          </Grid>
        </Grid.Container>
        <Spacer h={13} />
        <Text
          id="footer-copyright"
          font="12px"
          p
          style={{ textAlign: 'center' }}
        >
          © Copyright {new Date().getFullYear()}, Leaks Happen. Be Protected.℠ <br />{' '}
          <a href="https://louisvillewater.com/">Louisville Water Company</a>
        </Text>
        <Spacer h={3} />
      </Grid>
    </Grid.Container>
  )
}
